import { render } from "./totalpordia.vue?vue&type=template&id=6b9ac009&scoped=true"
import script from "./totalpordia.vue?vue&type=script&lang=js"
export * from "./totalpordia.vue?vue&type=script&lang=js"

import "./totalpordia.vue?vue&type=style&index=0&id=6b9ac009&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9ac009"]])

export default __exports__